module.exports = __webpack_public_path__ + "media/images/cts_logo-d7443574892aa21f3e19008f942515f8.gif";